import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { LambdaDao } from '@/interfaces/aws/Lambda.dao'

export default class AwsService extends ApiService {
    async getLambdas(params?: IRequestParameters): Promise<LambdaDao | null> {
        return this.request<undefined, LambdaDao | null>(
            'GET',
            '/api-logs/list-lambdas',
            params,
            undefined,
            undefined,
            'getLambdas',
        ).catch(() => null)
    }
    async queryInsightsByRequestId(params?: IRequestParameters): Promise<any[][] | null> {
        return this.request<undefined, any[][] | null>(
            'GET',
            '/api-logs/query-insights',
            params,
            undefined,
            undefined,
            'queryInsightsByRequestId',
        ).catch(() => null)
    }
}
